import React, { useEffect } from 'react';
import './CancellationPolicyBottomSheet.css';

const CancellationPolicyBottomSheet = ({ isOpen, onClose }) => {
    // Prevent scrolling on body when bottom sheet is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <>
            <div className={`cancellation-overlay ${isOpen ? 'show' : ''}`} onClick={onClose}></div>
            <div className={`cancellation-bottom-sheet ${isOpen ? 'show' : ''}`}>
                <div className="cancellation-sheet-header">
                    <div className="cancellation-drag-handle" onClick={onClose}></div>
                    <button className="cancellation-close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                <div className="cancellation-sheet-content">
                    <div className="cancellation-header-section">
                        <h1 className="cancellation-title cancellation-font-heading">Cancellation Policy</h1>
                    </div>

                    <div className="cancellation-section">
                        <h3 className="cancellation-font-heading">ORDER CANCELLATION BY CUSTOMER</h3>
                        <p>You may cancel your order at any time before dispatch.</p>
                        <p>Refunds for prepaid orders will be processed back to your original payment method. </p>
                    </div>

                    <div className="cancellation-section">
                        <h3 className="cancellation-font-heading">CANCELLATION POST-DISPATCH</h3>
                        <p>Once dispatched, orders cannot be cancelled—but you may refuse delivery. .</p>
                        <p>Refunds will be issued once the package returns to us (delivery charges may be deducted). </p>
                    </div>

                    <div className="cancellation-section">
                        <h3 className="cancellation-font-heading">ORDER CANCELLATION BY US</h3>
                        <p>We reserve the right to cancel any order under the following circumstances:</p>
                        <ul>
                            <li><strong>Stock Unavailability:</strong> If the requested items are out of stock.</li>
                            <li><strong>Pricing Errors:</strong> In the event of a listing error related to pricing or product description.</li>
                            <li><strong>Payment Issues:</strong> If there are complications or fraud suspicions regarding your payment method.</li>
                            <li><strong>Non-Serviceable Areas:</strong> If the delivery location falls outside our current service zones.</li>
                        </ul>
                        <p>If your order is cancelled by us, you will be notified via email or SMS, and any payments made will be fully refunded within 5-7 business days.</p>
                    </div>

                    <div className="cancellation-section">
                        <h3 className="cancellation-font-heading">REFUND PROCESS</h3>
                        <p>For all eligible cancellations, refunds will be processed to the original mode of payment (Credit/Debit Card, Net Banking, or UPI).</p>
                        <ul>
                            <li><strong>Prepaid Orders:</strong> Refunds typically take 5-7 business days to reflect in your account, depending on your bank's processing time.</li>
                            <li><strong>Wallet Payments:</strong> Refunds to store wallets are usually processed within 24 hours.</li>
                        </ul>
                    </div>

                    <div className="cancellation-section">
                        <h3 className="cancellation-font-heading">CONTACT US</h3>
                        <p>If you have any questions or need assistance with cancelling your order, please reach out to our customer support team at <strong>aarohfood@gmail.com</strong>.</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CancellationPolicyBottomSheet;
